mp.searchnav = {
    init: function () {
        $('.navbar-toggler').on('click', mp.searchnav.buildMenu); // für xs/sm
        $('#mpSearchNav').on('mouseover', mp.searchnav.buildMenu);

        // DEV-Helper
        //mp.searchnav.buildMenu();
    },

    running: false,
    done: false,

    buildMenu: function () {
        if (mp.searchnav.running === true || mp.searchnav.done === true) {
        } else {
            mp.searchnav.running = true;

            $.get('/searchnav', function (data) {
                $('#mpSearchNav').append(
                    Mustache.render(mp.templates.searchNav, data)
                );
                $('#mpSearchNav nav a:first-child').tab('show');
                $('#mpSearchNav nav a').hover(function () {
                    $(this).tab('show');
                });

                $('#mpSearchNav > a.dropdown-toggle').dropdown(); // alle DropDowns neu initialisieren

                mp.searchnav.done = true;
                mp.searchnav.running = false;

                // DEV-Helper
                //$('#mpSearchNav > .dropdown-menu').css('display','block');
            });
        }
    }
};

$(document).ready(function () {
    mp.searchnav.init();
});